import React, { useEffect, useState } from "react";
import "./../styles/Hero.css";
import heroImage from "../assets/main-rosas.png";
import heroVertical from "../assets/main-mobile.png";
import { Link } from "react-router-dom";
import "./../styles/NeonButton.css";

const Hero = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isMobile) {
    return (
      <section className="hero">
        <div
          className="hero-image-container"
          style={{
            backgroundImage: `url(${heroVertical})`,
            backgroundPosition: "center 25%",
          }}
        />
        <div className="hero-content">
          <h1>
            Asociación Proyecto <span className="pink">Chicas Rosas</span>
          </h1>
          <p className="hero-subtitle">
            La mejor forma de cuidarse es prevenir,
            <span> caminar es salud</span>
          </p>
          <Link to="/contacto" className="neon-button button-left">
            CAMINA CON NOSOTRAS
          </Link>
        </div>
      </section>
    );
  } else {
    return (
      <section
        className="hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="hero-content">
          <h1>
            Asociación Proyecto <span className="pink">Chicas Rosas</span>
          </h1>
          <p className="hero-subtitle">
            La mejor forma de cuidarse es prevenir,
            <span> caminar es salud</span>
          </p>
          <Link to="/contacto" className="neon-button button-left">
            CAMINA CON NOSOTRAS
          </Link>
        </div>
      </section>
    );
  }
};

export default Hero;
